module.exports = __webpack_public_path__ + "static/img/BA.34e6ce67.png";